/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceHowToPlayStep } from './SurfaceHowToPlayStep';
import {
    SurfaceHowToPlayStepFromJSON,
    SurfaceHowToPlayStepFromJSONTyped,
    SurfaceHowToPlayStepToJSON,
    SurfaceHowToPlayStepToJSONTyped,
} from './SurfaceHowToPlayStep';
import type { SurfaceRewardTier } from './SurfaceRewardTier';
import {
    SurfaceRewardTierFromJSON,
    SurfaceRewardTierFromJSONTyped,
    SurfaceRewardTierToJSON,
    SurfaceRewardTierToJSONTyped,
} from './SurfaceRewardTier';

/**
 * Rewards carousel configuration
 * @export
 * @interface SurfaceRewardsConfig
 */
export interface SurfaceRewardsConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardsConfig
     */
    sectionTitle?: string;
    /**
     * 
     * @type {Array<SurfaceRewardTier>}
     * @memberof SurfaceRewardsConfig
     */
    rewards?: Array<SurfaceRewardTier>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardsConfig
     */
    heroImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardsConfig
     */
    heroImageUrl?: string;
    /**
     * 
     * @type {Array<SurfaceHowToPlayStep>}
     * @memberof SurfaceRewardsConfig
     */
    howToPlaySteps?: Array<SurfaceHowToPlayStep>;
}

/**
 * Check if a given object implements the SurfaceRewardsConfig interface.
 */
export function instanceOfSurfaceRewardsConfig(value: object): value is SurfaceRewardsConfig {
    return true;
}

export function SurfaceRewardsConfigFromJSON(json: any): SurfaceRewardsConfig {
    return SurfaceRewardsConfigFromJSONTyped(json, false);
}

export function SurfaceRewardsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceRewardsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionTitle': json['sectionTitle'] == null ? undefined : json['sectionTitle'],
        'rewards': json['rewards'] == null ? undefined : ((json['rewards'] as Array<any>).map(SurfaceRewardTierFromJSON)),
        'heroImageId': json['heroImageId'] == null ? undefined : json['heroImageId'],
        'heroImageUrl': json['heroImageUrl'] == null ? undefined : json['heroImageUrl'],
        'howToPlaySteps': json['howToPlaySteps'] == null ? undefined : ((json['howToPlaySteps'] as Array<any>).map(SurfaceHowToPlayStepFromJSON)),
    };
}

export function SurfaceRewardsConfigToJSON(json: any): SurfaceRewardsConfig {
    return SurfaceRewardsConfigToJSONTyped(json, false);
}

export function SurfaceRewardsConfigToJSONTyped(value?: SurfaceRewardsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sectionTitle': value['sectionTitle'],
        'rewards': value['rewards'] == null ? undefined : ((value['rewards'] as Array<any>).map(SurfaceRewardTierToJSON)),
        'heroImageId': value['heroImageId'],
        'heroImageUrl': value['heroImageUrl'],
        'howToPlaySteps': value['howToPlaySteps'] == null ? undefined : ((value['howToPlaySteps'] as Array<any>).map(SurfaceHowToPlayStepToJSON)),
    };
}

